import { Link } from "@tanstack/react-router";
import { Instagram } from "lucide-react";
import img1 from "@/assets/model-jacket-woman.jpg";
import img2 from "@/assets/model-purse-cognac.jpg";
import img3 from "@/assets/model-belt-detail.jpg";
import img4 from "@/assets/product-jacket-black.jpg";
import img5 from "@/assets/product-belt-cognac.jpg";

const POSTS = [
  { handle: "@elena.r", city: "Milan, IT", img: img1, to: "/women" },
  { handle: "@james.w", city: "Brooklyn, US", img: img2, to: "/men" },
  { handle: "@amara.k", city: "London, UK", img: img3, to: "/accessories" },
  { handle: "@henrik.m", city: "Stockholm, SE", img: img4, to: "/men" },
  { handle: "@sofia.d", city: "Barcelona, ES", img: img5, to: "/accessories" },
] as const;

/**
 * "On the Gram" — UGC-style grid of clients wearing the maison.
 */
export function InstagramGrid() {
  return (
    <section className="bg-bone">
      <div className="container-luxe py-24 md:py-32">
        <div className="text-center mb-14 md:mb-20">
          <div className="eyebrow mb-5 flex items-center justify-center gap-2 text-gold">
            <Instagram className="h-3 w-3" /> On The Gram
          </div>
          <h2 className="font-serif font-light text-4xl md:text-5xl leading-[1.05] tracking-[-0.01em]">
            Worn by the world.
          </h2>
          <p className="mt-6 max-w-md mx-auto text-sm text-ash leading-relaxed font-light">
            Share your KAKAIYS with{" "}
            <span className="text-ink">#kakaiys</span> for a chance to be
            featured.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
          {POSTS.map((p) => (
            <Link
              key={p.handle}
              to={p.to}
              preload="intent"
              className="group relative block aspect-square overflow-hidden bg-secondary"
              aria-label={`Shop look from ${p.handle}`}
            >
              <img
                src={p.img}
                alt={`${p.handle} from ${p.city}`}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-3 left-3 right-3 text-bone opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="text-[11px] tracking-wide font-light">{p.handle}</div>
                <div className="text-[9px] uppercase tracking-[0.28em] text-bone/80 mt-0.5">
                  {p.city}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
